export class ConditionalIncentiveModel {
  id: number;
  accountId: number;
  groupAffiliationId: number;
  previousOwnershipId: number;
  applicationValue: string;

  constructor() {
    this.id = null;
    this.accountId = null;
    this.groupAffiliationId = null;
    this.previousOwnershipId = null;
    this.applicationValue = null;
  }
}
